module.exports = __webpack_public_path__ + "static/media/pagination.60a569a2.svg";